/**
 * Includes the object in the array
 * when the prop value is truthy.
 */
export const filterByProp = <Type, PropType extends keyof Type>(
  obj: Type,
  prop: keyof Type
): obj is Type & Record<PropType, NonNullable<Type[PropType]>> => {
  return !!obj[prop]
}
